export var ProducerConditionLevel;
(function (ProducerConditionLevel) {
    ProducerConditionLevel["Fatal"] = "fatal";
    ProducerConditionLevel["Error"] = "error";
    ProducerConditionLevel["Warning"] = "warning";
    ProducerConditionLevel["Info"] = "info";
    ProducerConditionLevel["Debug"] = "debug";
})(ProducerConditionLevel || (ProducerConditionLevel = {}));
